import React, { useEffect } from 'react';

import { useCommonAppServices } from '@provider-portal/common/services/ContextProviders';
import { useTargetingParameter } from '@provider-portal/common/services/TargetingService';
import config from '@provider-portal/common/config';

const HANDHOLD_SCRIPT_SRC = `${config.handHold.baseUrl}/demo/embed.js`;
const HANDHOLD_SCRIPT_ID = 'handhold-embed-script';

function getHandHoldLocale(currentLocale: string): string {
  return currentLocale.split('-')[0].toLowerCase();
}

const iframeStyle: React.CSSProperties = {
  position: 'fixed',
  bottom: '16px',
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 9999,
  border: 'none',
  outline: 'none',
  height: '0px',
  width: '0px',
  pointerEvents: 'auto',
};

function buildHandHoldIframeSrc(locale: string): string {
  const url = new URL(`${config.handHold.baseUrl}/demo/${config.handHold.agentId}/tour`);
  url.searchParams.set('mode', 'input');
  url.searchParams.set('locale', getHandHoldLocale(locale));
  return url.toString();
}

function HandHoldAgentEmbed({ iframeSrc }: { iframeSrc: string }) {
  useEffect(() => {
    if (document.getElementById(HANDHOLD_SCRIPT_ID)) {
      return;
    }
    const script = document.createElement('script');
    script.id = HANDHOLD_SCRIPT_ID;
    script.src = HANDHOLD_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <iframe key={iframeSrc} title="Bolt AI" src={iframeSrc} allow="autoplay" style={iframeStyle} />
  );
}

export interface HandHoldAgentProps {
  locale: string;
}

export function HandHoldAgent({ locale }: HandHoldAgentProps) {
  const { targetingService } = useCommonAppServices();
  const isHandHoldAgentEnabled = useTargetingParameter('handHoldAgent', targetingService, Boolean);
  const iframeSrc = buildHandHoldIframeSrc(locale);

  if (!isHandHoldAgentEnabled) {
    return null;
  }
  return <HandHoldAgentEmbed iframeSrc={iframeSrc} />;
}
